import { type ReactNode } from "react";

interface IJournalSectionContent {
    children: ReactNode;
  }

export const JournalSectionContent = ({ children }: IJournalSectionContent) => {
   
    return (
    <>
      {children}
    </>
    );
  };